import React from 'react';
import dayjs from '../helpers/dates';
import { isExpired, parseDateValue, isClosed } from '../helpers/utils';
import { TableCellExpiredText } from './Expired';

interface DaysLeftCellProps {
  row: {
    original: {
      deadline?: string;
      status?: string;
    };
  };
}

const DaysLeftCell = ({
  row: {
    original: { deadline, status },
  },
}: DaysLeftCellProps) => {
  const expired = isExpired(deadline);
  const closed = isClosed(status);
  if (deadline) {
    if (expired && !closed) {
      return <TableCellExpiredText>Past Due</TableCellExpiredText>;
    }
    if (closed) {
      return <span>N/A</span>;
    }

    return parseDateValue(deadline).diff(dayjs(), 'day');
  }
  return '';
};

export default DaysLeftCell;
